import ShowRow from "@/components/ShowRow/ShowRow";
import { ShowRowContent } from "@/lib/types/api/show-data";

import type { ShowBadgeFlags } from '@/components/ShowPoster/ShowPoster';

interface FeaturedShowsRowProps {
  shows: ShowRowContent[];
  showBadgeFlags?: ShowBadgeFlags;
}

const FeaturedShowsRow = (props: FeaturedShowsRowProps) => {
  const { shows, showBadgeFlags } = props;

  return (
    <ShowRow
      shows={shows}
      title={'Featured Shows'}
      showBadgeFlags={showBadgeFlags}
    />
  )
}

export default FeaturedShowsRow;
